export const API_URL =
  process.env.EXPO_PUBLIC_API_URL ?? "http://localhost:7401";

// On web, default to the current origin. React Native defines a global
// `window` (so `typeof window !== "undefined"` is TRUE on native), but
// `window.location` is undefined there — reading `.origin` unguarded throws
// "Cannot read property 'origin' of undefined" and hard-crashes the app at
// launch (it's eagerly evaluated when expo-router builds its route tree).
// Optional-chain `location` so native falls through to the next default.
const webOrigin =
  typeof window !== "undefined" ? window.location?.origin : undefined;

export const APP_URL =
  process.env.EXPO_PUBLIC_APP_URL ?? webOrigin ?? "http://localhost:7400";

// Public marketing/SEO site (Astro) — hosts the canonical /privacy, /terms,
// and /support pages the Settings → About section links out to.
export const WEB_URL =
  process.env.EXPO_PUBLIC_WEB_URL ?? "https://passfirst.io";
